import { styled } from "@mui/material";
import MuiRadio, { radioClasses, RadioProps } from "@mui/material/Radio";

const UncheckedIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.5" stroke="#BDC4CC" />
  </svg>
);

const StyledRadio = styled(MuiRadio, { shouldForwardProp: (prop) => prop !== "error" })<{ error?: boolean }>(
  ({ theme, error }) => ({
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    "&.Mui-focusVisible": {
      outline: "auto",
      outlineColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      opacity: 0.3,
    },
    "& svg": {
      borderRadius: "50%",
      boxShadow: !error ? undefined : `inset 0 0 0 2px ${theme.palette.error.main}`,
      "& circle": {
        stroke: !error ? undefined : theme.palette.error.main,
      },
    },
    [`&.${radioClasses.checked} svg`]: {
      borderRadius: "50%",
      boxShadow: !error
        ? `inset 0 0 0 4px ${theme.palette.secondary1[100]}`
        : `inset 0 0 0 4px ${theme.palette.error.main}`,
      "& circle": {
        stroke: !error ? theme.palette.secondary1[100] : theme.palette.error.main,
      },
    },
  })
);

function Radio(props: RadioProps & { error?: boolean }) {
  return <StyledRadio {...props} disableFocusRipple icon={UncheckedIcon} checkedIcon={UncheckedIcon} />;
}
export default Radio;
